import React from "react";
import Image from "gatsby-image";
import { useTeamPhotos } from "shared/Hooks/About/Team";
import { MatthiasImage } from "./MatthiasImage";

// icons todo
import VueIcon from "assets/images/technologies/vue.svg";

export const MatthiasData = () => {
  const images = MatthiasImage();
  const team_images = useTeamPhotos();
  return {
    color: "#111111",
    title: "Matthias",
    seo:
      "Naszym celem było przygotowanie i realizacja projektu nowego logo, wzoru opakowań produktów oraz wykonanie sesji produktowej ukazującej wyroby mięsne marki Matthias.",
    slug: "matthias",
    hero: {
      title: "Czas na rozwój marki.",
      color: "#111111",
      background: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"cover"}
          fluid={images.hero.childImageSharp.fluid}
        />
      ),
      detail: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.detail.childImageSharp.fluid}
        />
      ),
    },
    what_we_did: {
      title: "Nieszablonowy wizerunek marki z tradycją ",
      technologies: [
        "Identyfikacja wizualna",
        "UX Workshops",
        "Fotografia produktowa",
        "Social Media",
      ],
      text:
        "Wykonanie nowej identyfikacji wizualnej dla marki z wieloletnią tradycją nie jest łatwym zadaniem. Dlatego z dużym entuzjazmem podjęliśmy się tego wyzwania i zaprojektowaliśmy nowy branding dla firmy Matthias. Naszym celem było przygotowanie i realizacja projektu nowego logo, wzoru opakowań produktów oraz wykonanie sesji produktowej ukazującej wyroby mięsne marki Matthias. ",
      list: [
        "Opracowaliśmy rebranding marki",
        "Przygotowaliśmy schemat działań i design profili w social mediach",
        "Wykonaliśmy produktową sesję zdjęciową ",
      ],
    },
    logo: {
      first: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.logo.childImageSharp.fluid}
        />
      ),
    },
    list: {
      background: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.list_bg.childImageSharp.fluid}
        />
      ),
      detail: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.list_detail.childImageSharp.fluid}
        />
      ),
    },
    full_images: {
      first: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.mat_1f.childImageSharp.fluid}
          />
        ),
      },
      second: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.mat_2f.childImageSharp.fluid}
          />
        ),
      },
      third: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.mat_3f.childImageSharp.fluid}
          />
        ),
      },
      fourth: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.mat_4f.childImageSharp.fluid}
          />
        ),
      },
      fifth: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.mat_5f.childImageSharp.fluid}
          />
        ),
      },
      sixth: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.mat_6f.childImageSharp.fluid}
          />
        ),
      },
      seventh: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.mat_7f.childImageSharp.fluid}
          />
        ),
      },
      eighth: {
        title: "Tradycyjny, domowy charakter w nowoczesnej wersji",
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.mat_8f.childImageSharp.fluid}
          />
        ),
      },
      ninth: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.mat_9f.childImageSharp.fluid}
          />
        ),
      },

      tenth: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.mat_10f.childImageSharp.fluid}
          />
        ),
      },

      eleventh: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.mat_11f.childImageSharp.fluid}
          />
        ),
      },
      twelfth: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.mat_12f.childImageSharp.fluid}
          />
        ),
      },
      thirteenth: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.mat_13f.childImageSharp.fluid}
          />
        ),
      },
    },

    text_boxes: {
      first: {
        title: "Atrakcyjny przekaz dopasowany do każdego",
        text:
          "Marka w nowej odsłonie przyciąga uwagę minimalizmem formy i dociera również do młodszego pokolenia. Jej nowy wygląd nawiązuje do produktów, które posiada w swojej ofercie oraz wartości, którymi się kieruje. Są to atrakcyjne komunikaty zarówno dla młodszych, jak i starszych osób. ",
      },
      second: {
        title: "Nowoczesne logo swojskiej marki",
        text:
          "Do stworzenia logo wykorzystaliśmy świnkę, przez co zyskało ono lekko zabawny, „diabelski” charakter. Jest nawiązaniem do produktów Matthias, kojarzy się pozytywnie i nadaje marce przyjazny i optymistyczny wygląd.",
      },
      third: {
        title: "Ekskluzywna naturalność",
        text:
          "Projektując opakowania skupiliśmy się na prostocie - jest swojsko i naturalnie, ale nowocześnie. Design ten podkreśla wysoką jakość produktów i kojarzy się z ekskluzywnym towarem. Ponadto sprawia wrażenie produktu pełnowartościowego, który spełni oczekiwania nawet najbardziej wymagających klientów.",
      },
      fourth: {
        title: "Zdjęcia, przy których stajesz się głodny!",
        text:
          "Jednym z naszych zadań było również wykonanie fotografii produktowej i aranżowanej. Na zdjęciach podkreślono i uwypuklono wędliny i mięsa. Uporządkowane i wystylizowane ujęcia,  w których każdy szczegół ma znaczenie, zachęcają do sięgania po produkty. Fotografie dopełniają elementy, takie jak drewno, kamień czy przyprawy, zioła i warzywa.",
      },
      fifth: {
        title: "Skuteczna komunikacja dzięki nowemu brandingowi",
        text:
          "Wykonana nowa identyfikacja wizualna podkreśla wyjątkowość firmy Matthias, usprawnia komunikację z klientem oraz zachęca młodszych konsumentów do zainteresowania się ofertą. Dzięki temu marka ma szansę na wyróżnienie się wśród konkurencji.",
      },
    },
    technologies: {
      title: "Przykładowy dłuższy nagłówek dotyczący technologii",
      text: (
        <>
          Współpracę z agencją InteractiveVision wysoko cenimy za zaangażowanie,
          elastyczność oraz kompleksowość usług. Zawsze mogliśmy liczyć na
          profesjonalne doradztwo w zakresie planowanych działań oraz
          kreatywność.
          <br />
          <br />
          Dotychczasowa współpraca z tą firmą pozwala nam na rekomendowanie jej
          usług innym.
        </>
      ),
      icons: [
        { title: "Vue", icon: VueIcon },
        { title: "Vue", icon: VueIcon },
        { title: "Vue", icon: VueIcon },
        { title: "Vue", icon: VueIcon },
        { title: "Vue", icon: VueIcon },
        { title: "Vue", icon: VueIcon },
        { title: "Vue", icon: VueIcon },
      ],
    },
    marketing: {
      counts: [
        {
          count: "20%",
          title: "Zwiększona konwersja",
        },
        {
          count: 2000,
          title: "Polubień w 1 miesiąc",
        },
        {
          count: "53%",
          title: "zwiększona sprzedaż",
        },
      ],
      team: [
        {
          name: "Patrycja Bilska",
          position: "Project Manager",
          image: (
            <Image alt="" fluid={team_images.Patrycja.childImageSharp.fluid} />
          ),
        },
        {
          name: "Rafał Skórka",
          position: "Frontend Developer",
          image: (
            <Image alt="" fluid={team_images.Rafal.childImageSharp.fluid} />
          ),
        },
        {
          name: "Patryk Białas",
          position: "Graphic designer",
          image: (
            <Image alt="" fluid={team_images.Patryk.childImageSharp.fluid} />
          ),
        },
        {
          name: "Rafał Krawiec",
          position: "Backend Developer",
          image: (
            <Image alt="" fluid={team_images.Krawczyk.childImageSharp.fluid} />
          ),
        },
        {
          name: "Jakub Żmuda",
          position: "Marketing Specialist",
          image: (
            <Image alt="" fluid={team_images.Kuba.childImageSharp.fluid} />
          ),
        },
        {
          name: "Jakub Furman",
          position: "Sales Manager",
          image: (
            <Image alt="" fluid={team_images.Furman.childImageSharp.fluid} />
          ),
        },
      ],
    },
  };
};
